import styled from "styled-components";

export const PrivacyWrapper = styled.div`
  margin-top: 135px;
  margin-bottom: 0px;
  @media ${(props) => props.theme.tablet} {
    margin-top: 105px;
  }
  @media ${(props) => props.theme.mobile} {
    margin-top: 75px;
  }
`;

export const Path = styled.div`
  font-family: "KBFG Text";
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 17px;
  color: #ffac00;
  margin-bottom: 32px;
  span {
    font-family: "KBFG Text";
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 17px;
    color: #999999;
    :after {
      content: ">";
      margin: 0 14px;
    }
  }
  @media ${(props) => props.theme.laptop} {
    margin-left: 30px;
  }
  @media ${(props) => props.theme.tablet} {
    font-size: 15px;
    line-height: 19px;
    margin-bottom: 25px;
    margin-left: 0px;
    span {
      font-size: 15px;
      line-height: 19px;
    }
  }
  @media ${(props) => props.theme.mobile} {
    font-size: 13px;
    line-height: 19px;
    margin-bottom: 15px;
    span {
      font-size: 13px;
      line-height: 19px;
    }
  }
`;

export const MainTitle = styled.div`
  margin-bottom: 40px;
  h2 {
    font-family: "KBFG Display";
    font-style: normal;
    font-weight: 700;
    font-size: 50px;
    line-height: 62px;
    color: #1a1a1a;
    margin-bottom: 140px;
  }
  @media ${(props) => props.theme.laptop} {
    padding-left: 20px;
  }
  @media ${(props) => props.theme.tablet} {
    margin-bottom: 50px;
    padding-left: 0px;
    h2 {
      font-size: 50px;
      line-height: 72px;
    }
  }
  @media ${(props) => props.theme.mobile} {
    margin-bottom: 20px;
    h2 {
      margin-bottom: 25px;
      font-size: 30px;
      line-height: 35px;
      margin-bottom: 60px;
    }
  }
`;

export const MainPost = styled.div`
  height: 395px;
  margin-bottom: 85px;
  background-image: url(${(props) => props.theme.image_url}/common/Privacy_bg.png);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  @media ${(props) => props.theme.laptop} {
    background-attachment: scroll;
  }
  @media ${(props) => props.theme.tablet} {
    height: 480px;
    margin-bottom: 100px;
    background-position: center center;
  }
  @media ${(props) => props.theme.mobile} {
    height: 460px;
    margin-bottom: 90px;
    background-position: center center;
  }
`;

export const ContentContainer = styled.div`
  max-width: 1252px;
  margin: 0 auto;
  margin-bottom: 290px;
  p {
    font-family: "KBFG Text";
    font-style: normal;
    font-weight: 300;
    font-size: 17px;
    line-height: 30px;
    color: #000000;
  }
  @media ${(props) => props.theme.mobile} {
    margin-bottom: 60px;
  }
`;
export const PageContent = styled.div`
  line-height: 1.6 !important;
  /* h1,
  h2,
  h3,
  h4,
  h5 {
    margin-bottom: 25px;
  }
  p {
    margin-bottom: 25px;
    color: #888;
  }
  ul {
    list-style: square;
    margin-bottom: 25px;
    margin-top: 15px;
  }
  li {
    line-height: 1.8;
    margin-bottom: 10px;
    margin-left: 20px;
    color: #888;
  }
  table {
    border: 1px solid #eee;
    margin-bottom: 25px;
    th {
      background: #f7f7f7;
    }
    td,
    th {
      padding: 10px;
      border: 1px solid #eee;
      vertical-align: middle;
      line-height: 1.7;
    }
  } */

  .area {
    margin-bottom: 60px;
  }
  strong {
    display: block;
    font-size: 30px;
    margin-top: 100px;
    margin-bottom: 40px;
  }
  .o {
    font-size: 16px;
    margin-bottom: 6px;
  }
  .d {
    font-size: 15px;
    margin-bottom: 30px;
  }
  p {
    color: #000;
    font-weight: 600;
    font-size: 18px;
    margin-top: 30px;
    margin-bottom: 14px;
  }
  span {
    display: block;
    font-size: 14px;
    margin-bottom: 4px;
    word-break: keep-all;
  }

  @media ${(props) => props.theme.mobile} {
    .area {
      margin-bottom: 30px;
    }
    strong {
      display: block;
      font-size: 19px;
      margin-top: 50px;
      margin-bottom: 20px;
    }
    .o {
      font-size: 12px;
      margin-bottom: 8px;
    }
    .d {
      font-size: 12px;
      margin-bottom: 12px;
    }
    p {
      color: #000;
      font-weight: 600;
      font-size: 15px;
      margin-top: 18px;
      margin-bottom: 4px;
    }
    span {
      display: block;
      font-size: 11px;
      margin-bottom: 3px;
      word-break: keep-all;
    }
  }
`;

export const Select = styled.select`
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  /* 생략 */
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;

  color: #444;
  background-color: #fff;

  padding: 0.6em 1.4em 0.5em 0.8em;
  margin: 0;
  margin-bottom: 40px;

  border: 1px solid #aaa;
  border-radius: 0.5em;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
`;
